export const ACTION_LABELS = {
  ticket_created: "Ticket created",
  checked_in: "Checked in",
  terms_signed: "T&C signed",
  payment_charged: "Payment charged",
  payment_preauthorized: "Payment pre-authorized",
  renewed: "Renewed",
  auto_renewed: "Auto-renewal charged",
  overstay_charged: "Overstay charged",
  auto_charge_declined: "Auto-charge declined",
  balance_collected: "Balance collected",
  balance_declined: "Balance charge declined",
  balance_written_off: "Balance written off",
  free_night_applied: "Free night applied",
  fields_edited: "Details edited",
  checked_out: "Checked out",
  dispute_packet_generated: "Dispute packet generated",
};

const ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
const show = (v) => (typeof v === "string" && ISO.test(v) ? new Date(v).toLocaleString() : String(v));

export const changeText = (c) =>
  c.old === null || c.old === undefined || c.old === ""
    ? `${c.label} added now '${show(c.new)}'`
    : `${c.label} changed from '${show(c.old)}' to '${show(c.new)}'`;

export const stamp = (iso) => new Date(iso).toLocaleString([], {
  year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
});
